import { Modal } from 'antd';
import React, { FC, useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { IRootReducers } from 'src/reducers';
import { ConsumableNatureEnum } from 'src/shared/enums';
import { ConsumablesContext } from './consumables';
import ConsumablesModalBonusList from './consumablesModalBonusList';
import ConsumablesModalPointsSummary from './consumablesModalPointsSummary';

const mapStateToProps = (state: IRootReducers) => {
  return {
    scanData: state.app.scanData,
  };
};

type ConsumablesModalProps = ReturnType<typeof mapStateToProps>;

const ConsumablesModal: FC<ConsumablesModalProps> = ({ scanData }) => {
  const {
    showModal,
    consumablesStep,
    setConsumablesStep,
    listStep,
    pointsSummaryStep,
    setScannedConsumableVariant,
    setCustomerCoupons,
    setNewCoupon,
    setIsDI,
    setWelcome,
    skipCoupon,
  } = useContext(ConsumablesContext);

  const { consumable, newCoupon, userConsumableCoupon, welcome } = scanData;

  useEffect(() => {
    setWelcome(welcome);
    setCustomerCoupons(userConsumableCoupon);

    // Caso de nuevo registro en LICON
    if (welcome) {
      setConsumablesStep(pointsSummaryStep);
      return;
    }

    // Caso de usuario con cuenta
    setScannedConsumableVariant(scanData.consumable);
    setNewCoupon(newCoupon);
    setIsDI(
      consumable?.nature === ConsumableNatureEnum.DI ||
        consumable?.nature === ConsumableNatureEnum.DI_SAP,
    );
    // Elegimos el paso del modal según el tipo de producto escaneado y los cupones que tiene el usuario
    setConsumablesStep(
      consumable?.nature === ConsumableNatureEnum.DI ||
        consumable?.nature === ConsumableNatureEnum.DI_SAP
        ? pointsSummaryStep
        : userConsumableCoupon?.length !== 0
        ? listStep
        : pointsSummaryStep,
    );
  }, []);

  const renderConsumablesModalStep = () => {
    if (showModal) {
      switch (consumablesStep) {
        case listStep:
          return <ConsumablesModalBonusList />;
        case pointsSummaryStep:
          return <ConsumablesModalPointsSummary />;
      }
    }
    return;
  };

  let consumableIsDI =
    consumable?.nature === ConsumableNatureEnum.DI ||
    consumable?.nature === ConsumableNatureEnum.DI_SAP;

  let modalID = consumableIsDI
    ? 'sample-generate-coupon'
    : 'product-generate-coupon';

  if (!consumableIsDI && userConsumableCoupon?.length !== 0) {
    modalID = 'apply-coupon';
  }

  return (
    <Modal
      visible={showModal}
      footer={null}
      closable={false}
      className="consumables-modal"
      centered>
      <div id={modalID} className="consumables-step">
        {renderConsumablesModalStep()}
      </div>
    </Modal>
  );
};

export default connect(mapStateToProps, null)(ConsumablesModal);
